import InstanceSettings from './InstanceSettings';

export default InstanceSettings;
